// @flow
import { handleActions } from 'redux-actions';
import { fromJS } from 'immutable';

import handleReduce from '~/core/state/handle-reduce';
import * as constants from './constants';

export const reducers = {
    // $FlowFixMe
    [constants.CHECK_SERVICE_OUTAGE_STATUS]: handleReduce(state => state.set('isFetching', true)),
    [constants.RECEIVE_SERVICE_OUTAGE_STATUS]: handleReduce(
        // $FlowFixMe
        (state, { payload }) =>
            // $FlowFixMe
            state.withMutations(state =>
                state
                    .set('isFetching', false)
                    .set('isLoaded', true)
                    .set('hasError', false)
                    .set('payload', fromJS(payload))
                    .set('showServiceOutage', true)
            ),
        state =>
            // $FlowFixMe
            state.withMutations(state =>
                state
                    .set('isFetching', false)
                    .set('isLoaded', true)
                    .set('hasError', true)
                    .set('payload', fromJS({}))
                    .set('showServiceOutage', false)
            )
    ),
    // $FlowFixMe
    [constants.SHOW_ALERT_NOTIFICATION]: handleReduce(state => state.set('showServiceOutage', true)),
    // $FlowFixMe
    [constants.HIDE_ALERT_NOTIFICATION]: handleReduce(state => state.set('showServiceOutage', false))
};

const defaultState = fromJS({
    isFetching: false,
    hasError: false,
    isLoaded: false,
    showServiceOutage: false,
    payload: {}
});

export default handleActions(reducers, defaultState);



// WEBPACK FOOTER //
// ./src/core/state/service-outage/index.js